/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState
} from '@sg/api/base-api-lib';
import { BroadcastApiConfig } from '../api-config';

import { BroadcastApi } from '../models';

@Injectable()
export class BroadcastTemplateSpecificRecipientsApiClient extends BaseApiClient<
  BroadcastApiConfig
> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.broadcastApiConfig);
  }

  templateSpecificRecipientsControllerUpsertTemplateSpecificRecipients(
    body: BroadcastApi.UpsertTemplateSpecificRecipientDto,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<Array<string>>;
  templateSpecificRecipientsControllerUpsertTemplateSpecificRecipients(
    body: BroadcastApi.UpsertTemplateSpecificRecipientDto,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<Array<string>>>;
  templateSpecificRecipientsControllerUpsertTemplateSpecificRecipients(
    body: BroadcastApi.UpsertTemplateSpecificRecipientDto,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<Array<string>>;
  templateSpecificRecipientsControllerUpsertTemplateSpecificRecipients(
    body: BroadcastApi.UpsertTemplateSpecificRecipientDto,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<Array<string>>>;
  templateSpecificRecipientsControllerUpsertTemplateSpecificRecipients(
    body: BroadcastApi.UpsertTemplateSpecificRecipientDto,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<Array<string>>>;
  templateSpecificRecipientsControllerUpsertTemplateSpecificRecipients(
    body: BroadcastApi.UpsertTemplateSpecificRecipientDto,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<Array<string>>>;
  templateSpecificRecipientsControllerUpsertTemplateSpecificRecipients(
    body: BroadcastApi.UpsertTemplateSpecificRecipientDto,

    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', body]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<string>>(
      `${this.basePath}/gateway/admin/broadcast/template-specific-recipients`,
      body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  templateSpecificRecipientsControllerSearchTemplateSpecificRecipients(
    body: BroadcastApi.SearchTemplateSpecificRecipientsDto,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<Array<BroadcastApi.TemplateSpecificRecipientDto>>;
  templateSpecificRecipientsControllerSearchTemplateSpecificRecipients(
    body: BroadcastApi.SearchTemplateSpecificRecipientsDto,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<Array<BroadcastApi.TemplateSpecificRecipientDto>>>;
  templateSpecificRecipientsControllerSearchTemplateSpecificRecipients(
    body: BroadcastApi.SearchTemplateSpecificRecipientsDto,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<Array<BroadcastApi.TemplateSpecificRecipientDto>>;
  templateSpecificRecipientsControllerSearchTemplateSpecificRecipients(
    body: BroadcastApi.SearchTemplateSpecificRecipientsDto,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<Array<BroadcastApi.TemplateSpecificRecipientDto>>>;
  templateSpecificRecipientsControllerSearchTemplateSpecificRecipients(
    body: BroadcastApi.SearchTemplateSpecificRecipientsDto,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<Array<BroadcastApi.TemplateSpecificRecipientDto>>>;
  templateSpecificRecipientsControllerSearchTemplateSpecificRecipients(
    body: BroadcastApi.SearchTemplateSpecificRecipientsDto,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<Array<BroadcastApi.TemplateSpecificRecipientDto>>>;
  templateSpecificRecipientsControllerSearchTemplateSpecificRecipients(
    body: BroadcastApi.SearchTemplateSpecificRecipientsDto,

    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', body]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<BroadcastApi.TemplateSpecificRecipientDto>>(
      `${this.basePath}/gateway/admin/broadcast/template-specific-recipients/search`,
      body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  templateSpecificRecipientsControllerDeleteTemplateSpecificRecipients(
    id: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<any>;
  templateSpecificRecipientsControllerDeleteTemplateSpecificRecipients(
    id: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<any>>;
  templateSpecificRecipientsControllerDeleteTemplateSpecificRecipients(
    id: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<any>;
  templateSpecificRecipientsControllerDeleteTemplateSpecificRecipients(
    id: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<any>>;
  templateSpecificRecipientsControllerDeleteTemplateSpecificRecipients(
    id: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<any>>;
  templateSpecificRecipientsControllerDeleteTemplateSpecificRecipients(
    id: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<any>>;
  templateSpecificRecipientsControllerDeleteTemplateSpecificRecipients(
    id: string,

    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', id]);

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.delete<any>(
      `${this.basePath}/gateway/admin/broadcast/template-specific-recipients/${this.encodeURI(
        String(id)
      )}`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
